import {
  ActionButtons,
  DataTable,
  type DataTableColumn,
  type DataTableRow,
} from '@enamelai/design-system'
import { InvoiceEntry } from '@dataTypes/billing.types'
import { formatCurrency, formatInvoiceNumber } from '@utils/billing.utils'
import React, { useMemo } from 'react'
import './PaymentTableStyle.css'

interface Props {
  filteredPayments: InvoiceEntry[]
  handleRemoveFromSelection: (invoiceNo: string) => void
}

const PaymentOutstandingTable: React.FC<Props> = ({
  filteredPayments,
  handleRemoveFromSelection,
}) => {
  const rows = useMemo(
    (): DataTableRow[] =>
      filteredPayments.map((invoice) => ({
        id: invoice.invoiceNo,
        invoiceNo: formatInvoiceNumber(invoice.invoiceNo),
        invoiceDate: invoice.invoiceDate,
        patientName: invoice.patientName,
        patientResponsibilityBalance: formatCurrency(
          invoice.patientResponsibilityBalance,
        ),
      })),
    [filteredPayments],
  )

  const columns = useMemo(
    (): DataTableColumn[] => [
      { id: 'invoiceNo', label: 'Invoice no.', width: '170px' },
      { id: 'invoiceDate', label: 'Invoice date', width: '170px' },
      { id: 'patientName', label: 'Patient name', width: '170px' },
      {
        id: 'patientResponsibilityBalance',
        label: 'Amount due',
        width: '170px',
      },
    ],
    [],
  )

  const renderActions = (row: DataTableRow): React.ReactNode => (
    <ActionButtons onDelete={() => handleRemoveFromSelection(row.id)} />
  )

  return (
    <DataTable
      className="payment-outstanding-table"
      columns={columns}
      rows={rows}
      showActions
      actionsLabel="Actions"
      renderActions={renderActions}
    />
  )
}

export default PaymentOutstandingTable
